type QuestionStepProps = {
  question: string;
  answer: string;
  onAnswerChange: (answer: string) => void;
};

export const QuestionStep = ({ question, answer, onAnswerChange }: QuestionStepProps) => {
  return (
    <div>
      <h3 className="text-base sm:text-lg font-termina font-semibold text-[#111827] mb-4 sm:mb-6">
        {question}
      </h3>
      <textarea
        value={answer}
        onChange={(e) => onAnswerChange(e.target.value)}
        placeholder="Type your answer here..."
        className="w-full min-h-[200px] rounded-lg border border-[#026857] bg-white px-4 py-3 text-sm font-termina text-[#111827] placeholder:text-[#A3A7B5] focus:border-[#026857] focus:outline-none focus:ring-2 focus:ring-[#026857]/20 resize-y"
        rows={8}
      />
    </div>
  );
};

